
import React, { Component } from 'react';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { SolidFill } from '@src/slide/domain/ui-model/plugin/referModels/FillClass';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { DISABLE_OPACITY } from '@com-m/tool-bar-m/toolbar-item-hoc';
import styles from './index.css';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { IColorPickerManager } from '@src/slide/application/service/color-picker-manager/color-picker-manager.interface';

interface IColorBaseItemProps {
    id: string | undefined;
    selected: boolean;
    defaultValue: string | undefined;
    value: string | undefined;
    disabled: boolean | undefined;
    showFirstNoColorIcon?: boolean;
    setSelectedColor: (colorValue: string) => void;
    colorPickerManager?: IColorPickerManager;
}

export default class ColorItem extends Component<IColorBaseItemProps> {
    private iconRef;

    public componentDidMount() {
        if (this.iconRef) {
            // 通过addEventListener添加事件，并提供preventDefault,可以阻止mouse事件。避免移动端重复触发
            this.iconRef.addEventListener('click', this.setColorValue);
        }
    }

    public componentWillUnmount() {
        if (this.iconRef) {
            this.iconRef.removeEventListener('click', this.setColorValue);
        }
    }

    public render() {
        const { selected, defaultValue, disabled, showFirstNoColorIcon } = this.props;
        return <div
            className={styles['color-edit-item']}
            onMouseDown={this.handleMouseDown}
            ref={(el) => {
                this.iconRef = el;
            }}
            style={{
                borderColor: selected ? 'black' : 'transparent',
                opacity: disabled ? DISABLE_OPACITY : 1,
            }}>
            <div
                className={styles['color-edit-item-inner']}
                style={{
                    backgroundColor: defaultValue,
                }}
            >
                {
                    showFirstNoColorIcon && <div className={styles['no-color-icon']}/>
                }
            </div>
        </div>;
    }

    private handleMouseDown = (e) => {
        this.setColorValue(e);
    };

    private setColorValue = (e) => {
        const { id, defaultValue, setSelectedColor, showFirstNoColorIcon } = this.props;
        const tdColor = new TDColor({
            rgbaStr: defaultValue,
        });
        if (this.isNeedRejectOperate(id)) {
            return;
        }
        const curModel = this.getAppServices().viewableServiceLayer.selectionService.selectedElements.getCurrentModel();
        this.props.colorPickerManager?.setRecentColor(tdColor.getColorWithNoAlpha());
        if (id === ActionType.FILLCOLOR) {
            curModel.getBackgroundFill().updateCurrentFill({ solidFill: new SolidFill(defaultValue) });
            return;
        }
        if (id === ActionType.BORDERCOLOR) {
            curModel?.getBorder?.()?.updateCurrentBorder({ color: defaultValue, tdColor });
            if (showFirstNoColorIcon) {
                curModel?.getBorder?.()?.updateCurrentBorder({ color: null, width: 0, tdColor: null });
                return;
            }
            return;
        }
        // const value: string | any = defaultValue;
        setSelectedColor(tdColor.srgb_color);
        const callback = this.getMenuManager()?.stylePanelMenu().callback;
        callback?.(MenuType.TOOLBAR, id, tdColor);
        e.preventDefault();
    };
    private isNeedRejectOperate(id: string | undefined) {
        const isNoteArea = this.getAppServices().viewableServiceLayer
            .selectionService.selectedElements.getCurrentModel().type === UIModelType.NOTE;
        return isNoteArea && (id === ActionType.BORDERCOLOR || id === ActionType.FILLCOLOR);
    }

    private getAppServices(): IMobileEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IMobileEditorAppServices;
    }

    private getMenuManager() {
        return this.getAppServices().editableServiceLayer?.menuManager;
    }
}
